export * from './PayInMethodLabel'
